/**
 * Syntax-check an algo workbench script the same way the server compiles it:
 * as the body of `async function (alpaca, console, helpers) { … }`.
 *
 * @param {string} script
 * @returns {{ ok: boolean, message?: string, line?: number|null, column?: number|null }}
 */
export function checkAlgoScriptSyntax(script) {
  const src = String(script ?? '');
  if (!src.trim()) {
    return { ok: false, message: 'Script is empty', line: null, column: null };
  }

  try {
    const AsyncFunction = Object.getPrototypeOf(async function () {}).constructor;
    // Compile only — never invoke.
    // eslint-disable-next-line no-new
    new AsyncFunction('alpaca', 'console', 'helpers', src);
    return { ok: true };
  } catch (err) {
    const message = String(err?.message || err || 'Syntax error');
    // V8 / Chrome: "Unexpected token '}'" or "... (at <anonymous>:3:5)"
    // Firefox: "... at line 3:5"
    let line = null;
    let column = null;
    const anon = message.match(/<anonymous>:(\d+)(?::(\d+))?/);
    const atLine = message.match(/\bat line (\d+)(?::(\d+))?/i);
    const colon = message.match(/:(\d+):(\d+)\s*$/);
    const m = anon || atLine || colon;
    if (m) {
      line = Number(m[1]);
      column = m[2] != null ? Number(m[2]) : null;
      // AsyncFunction body line numbers are 1-based within the script.
      if (Number.isFinite(line) && line > 0) {
        /* keep */
      } else {
        line = null;
      }
    }
    return {
      ok: false,
      message: message.replace(/\s*\(at <anonymous>:[^)]+\)\s*$/, '').trim(),
      line: Number.isFinite(line) ? line : null,
      column: Number.isFinite(column) ? column : null,
    };
  }
}
